import detailStyles from '../ChallengeDetail.module.scss';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';
import image1 from './images/1-1.jpg';
import image2 from './images/1-2.jpg';

export const EnterTheRegularDrawDescription = () => {
    return (
        <div className={detailStyles.description}>
            <p>
                <div>
                    Перейдите в раздел <b>«Подарки»</b>
                </div>
                <ChallengeDetailHelpImage image={image1} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Нажмите кнопку <b>«Принять участие»</b> в 3-х разных розыгрышах за серые билеты
                </div>
                <ChallengeDetailHelpImage image={image2} helpText='Это картинка. Ищите кнопку в разделе «Подарки».' />
            </p>
        </div>
    );
}